module.exports = __webpack_public_path__ + "img/KGoldcorazon.0b577c34.png";